import * as types from './types'

export default {
  [types.SET_LOADING](state, isLoading) {
    state.loading = isLoading
  },
  [types.SET_ERROR](state, error) {
    state.error = error
  },
  [types.SET_CONTEXT](state, payload) {
    // Normalise casing from API
    const md = payload.manufacturerDevices || payload.ManufacturerDevices || []
    const cd = payload.connectedDevices || payload.ConnectedDevices || []

    state.manufacturerDevices = md
    state.connectedDevices = cd
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/connecteddevices/mutations.js